import React from "react";
import { Col, Card } from "reactstrap";
import PropTypes from "prop-types";
// import Skeleton from '@material-ui/lab/Skeleton';
// import './styles.scss';

/*=============================================
=            Card Toptals Conponent           =
=============================================*/
function CardTotals(props) {
  return (
    <Col xs="12" md="4" lg="2" className="mb-3">
      <Card className="flex-row align-items-stretch border-0 shadow-sm">
        {/* LEFT */}
        <div className="d-flex flex-column align-items-center justify-content-center rounded-left p-3 bgg-gray-dark">
          <img src={props.image} height="30" width="30" alt="icon" />
          <div
            className="h4 mt-2"
            style={{ color: "#000", fontWeight: "bold" }}
          >
            {props.total}
          </div>
        </div>

        {/* RIGHT */}
        <div className="d-flex flex-fill py-3 bgg-gray align-items-center justify-content-center rounded-right">
          <div
            style={{
              color: "#000",
              fontSize: "medium",
              textAlign: "center",
            }}
          >
            {props.title}
          </div>
        </div>
      </Card>
      {/* <Card className="myCard2"> */}
      {/* <CardBody style= {{marginBottom:'-1em'}}> */}
      {/*       <div className="card flex-row align-items-center justify-content-center align-items-stretch border-0">
        <div className="flex-col bgg-gray-dark align-items-center justify-content-center rounded-left p-3">
          <img
            // style={{ margin: "6px", marginTop: "-1px" }}
            src={props.image}
            height="30"
            width="30"
          ></img>
          <div
            className="h4 mt-2"
            style={{ color: "#000", fontWeight: "bold" }}
          >
            {props.total}
          </div>
        </div>

        <div className={props.propertiesTitle}>
          <div className="" style={{ color: "#000", fontSize: "medium" }}>
            {props.title}
          </div>
        </div>
      </div> */}
      {/* </CardBody> */}
      {/* </Card> */}
    </Col>
  );
}

// Especifica los valores por defecto de props:
CardTotals.defaultProps = {
  xl: 3,
  md: 6,
  sm: 12,
};

CardTotals.propTypes = {
  xl: PropTypes.number,
  md: PropTypes.number,
  sm: PropTypes.number,
  propertiesIcon: PropTypes.string,
  image: PropTypes.element,
  propertiesTitle: PropTypes.string,
  total: PropTypes.number,
  title: PropTypes.string,
};

export default CardTotals;
